
(() => {
  'use strict';

  const MOBILE_QUERY = '(max-width: 989px)';
  const PANEL_ID = 'CarlouhMobileSearchPanel';
  const INPUT_ID = 'CarlouhMobileSearchInput';
  const RESULTS_ID = 'CarlouhMobileSearchResults';
  const MIN_CHARS = 2;
  const RESULT_LIMIT = 4;
  const DEBOUNCE_MS = 220;

  let debounceTimer = null;
  let activeRequest = null;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getElements() {
    const section = document.querySelector('.section-header');
    if (!section) return {};

    const trigger =
      section.querySelector('summary.header__icon--search') ||
      section.querySelector('.header__icon--search') ||
      section.querySelector('details-modal.header__search summary');

    const details = trigger ? trigger.closest('details') : null;
    const header =
      section.querySelector('header.header') ||
      section.querySelector('.header');

    return { section, trigger, details, header };
  }

  function buildPanel(section, header) {
    let panel = document.getElementById(PANEL_ID);
    if (panel) return panel;

    panel = document.createElement('div');
    panel.id = PANEL_ID;
    panel.className = 'carlouh-mobile-search';
    panel.hidden = true;

    panel.innerHTML = `
      <form class="carlouh-mobile-search__form" action="${rootPath()}search" method="get" role="search">
        <label class="visually-hidden" for="${INPUT_ID}">Shop durchsuchen</label>
        <input
          id="${INPUT_ID}"
          class="carlouh-mobile-search__input"
          type="search"
          name="q"
          placeholder="Wonach suchst du?"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          aria-controls="${RESULTS_ID}"
          aria-autocomplete="list"
          aria-expanded="false"
        >
        <button class="carlouh-mobile-search__submit" type="submit" aria-label="Suchen"></button>
        <button class="carlouh-mobile-search__close" type="button" aria-label="Suche schließen"></button>
      </form>

      <div
        id="${RESULTS_ID}"
        class="carlouh-mobile-search__results"
        role="region"
        aria-live="polite"
        hidden
      ></div>
    `;

    if (header && header.parentNode) {
      header.insertAdjacentElement('afterend', panel);
    } else {
      section.appendChild(panel);
    }

    return panel;
  }

  function closeNative(details) {
    if (details && details.hasAttribute('open')) {
      details.removeAttribute('open');
    }
  }

  function formatPrice(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';

    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'EUR';

    const locale = document.documentElement.lang || 'de-DE';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(number);
    } catch (_) {
      return `${number.toFixed(2).replace('.', ',')} €`;
    }
  }

  function imageUrl(product) {
    return (
      (product.featured_image && product.featured_image.url) ||
      product.image ||
      ''
    );
  }

  function productPrice(product) {
    if (product.price_min !== undefined && product.price_min !== null) {
      return product.price_min;
    }
    return product.price;
  }

  function clearResults(results, input) {
    results.replaceChildren();
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  }

  function showLoading(results, input) {
    results.replaceChildren();

    const p = document.createElement('p');
    p.className = 'carlouh-mobile-search__loading';
    p.textContent = 'Passende Produkte werden gesucht …';

    results.appendChild(p);
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function buildAllResultsLink(query) {
    const link = document.createElement('a');
    link.className = 'carlouh-mobile-search__all';
    link.href = `${rootPath()}search?q=${encodeURIComponent(query)}`;
    link.textContent = `Alle Ergebnisse für „${query}“ anzeigen →`;
    return link;
  }

  function renderProducts(results, input, query, products) {
    results.replaceChildren();

    const head = document.createElement('div');
    head.className = 'carlouh-mobile-search__results-head';

    const title = document.createElement('p');
    title.className = 'carlouh-mobile-search__results-title';
    title.textContent = 'Passende Produkte';

    const queryText = document.createElement('p');
    queryText.className = 'carlouh-mobile-search__results-query';
    queryText.textContent = `${products.length} Treffer`;

    head.append(title, queryText);
    results.appendChild(head);

    if (!products.length) {
      const empty = document.createElement('p');
      empty.className = 'carlouh-mobile-search__empty';
      empty.textContent = 'Keine direkten Produkttreffer. Über die vollständige Suche können weitere Ergebnisse gefunden werden.';
      results.appendChild(empty);
      results.appendChild(buildAllResultsLink(query));
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    const list = document.createElement('ul');
    list.className = 'carlouh-mobile-search__list';
    list.setAttribute('role', 'list');

    products.forEach((product) => {
      const li = document.createElement('li');
      li.className = 'carlouh-mobile-search__item';

      const link = document.createElement('a');
      link.className = 'carlouh-mobile-search__product';
      link.href = product.url;

      const imageWrap = document.createElement('span');
      imageWrap.className = 'carlouh-mobile-search__image-wrap';

      const src = imageUrl(product);
      if (src) {
        const img = document.createElement('img');
        img.className = 'carlouh-mobile-search__image';
        img.src = src;
        img.alt =
          (product.featured_image && product.featured_image.alt) ||
          product.title ||
          '';
        img.loading = 'lazy';
        imageWrap.appendChild(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'carlouh-mobile-search__image-placeholder';
        placeholder.textContent = 'CARLOUH';
        imageWrap.appendChild(placeholder);
      }

      const info = document.createElement('span');
      info.className = 'carlouh-mobile-search__product-info';

      const productTitle = document.createElement('span');
      productTitle.className = 'carlouh-mobile-search__product-title';
      productTitle.textContent = product.title || 'Produkt';

      const price = document.createElement('span');
      price.className = 'carlouh-mobile-search__price';
      price.textContent = formatPrice(productPrice(product));

      info.append(productTitle, price);

      const arrow = document.createElement('span');
      arrow.className = 'carlouh-mobile-search__arrow';
      arrow.setAttribute('aria-hidden', 'true');

      link.append(imageWrap, info, arrow);
      li.appendChild(link);
      list.appendChild(li);
    });

    results.appendChild(list);
    results.appendChild(buildAllResultsLink(query));

    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  async function fetchSuggestions(query, results, input) {
    if (activeRequest) {
      activeRequest.abort();
    }

    activeRequest = new AbortController();

    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', String(RESULT_LIMIT));
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'hide');

    showLoading(results, input);

    try {
      const response = await fetch(
        `${rootPath()}search/suggest.json?${params.toString()}`,
        {
          method: 'GET',
          headers: { Accept: 'application/json' },
          signal: activeRequest.signal
        }
      );

      if (!response.ok) {
        throw new Error(`Predictive search failed: ${response.status}`);
      }

      const data = await response.json();
      const products =
        data &&
        data.resources &&
        data.resources.results &&
        Array.isArray(data.resources.results.products)
          ? data.resources.results.products
          : [];

      /* Nur rendern, wenn die Eingabe noch dieselbe ist */
      if (input.value.trim() !== query) return;

      renderProducts(results, input, query, products);
    } catch (error) {
      if (error.name === 'AbortError') return;

      /* Bei API-/Locale-Problemen die Suche selbst nicht kaputt machen */
      results.replaceChildren();
      const empty = document.createElement('p');
      empty.className = 'carlouh-mobile-search__empty';
      empty.textContent = 'Vorschläge sind gerade nicht verfügbar. Die normale Suche funktioniert weiterhin.';
      results.appendChild(empty);
      results.appendChild(buildAllResultsLink(query));
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  }

  function scheduleSuggestions(query, results, input) {
    window.clearTimeout(debounceTimer);

    if (query.length < MIN_CHARS) {
      if (activeRequest) activeRequest.abort();
      clearResults(results, input);
      return;
    }

    debounceTimer = window.setTimeout(() => {
      fetchSuggestions(query, results, input);
    }, DEBOUNCE_MS);
  }

  function setup() {
    const { section, trigger, details, header } = getElements();
    if (!section || !trigger) return;

    const panel = buildPanel(section, header);
    const input = panel.querySelector('.carlouh-mobile-search__input');
    const close = panel.querySelector('.carlouh-mobile-search__close');
    const results = panel.querySelector('.carlouh-mobile-search__results');

    if (!input || !close || !results) return;
    if (trigger.dataset.carlouhSearchBound === 'true') return;

    trigger.dataset.carlouhSearchBound = 'true';

    trigger.addEventListener('click', (event) => {
      if (!isMobile()) return;

      event.preventDefault();
      event.stopPropagation();
      closeNative(details);

      const willOpen = panel.hidden;
      panel.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        window.requestAnimationFrame(() => {
          input.focus();
          const query = input.value.trim();
          if (query.length >= MIN_CHARS) {
            scheduleSuggestions(query, results, input);
          }
        });
      } else {
        clearResults(results, input);
      }
    }, true);

    input.addEventListener('input', () => {
      scheduleSuggestions(input.value.trim(), results, input);
    });

    input.addEventListener('search', () => {
      scheduleSuggestions(input.value.trim(), results, input);
    });

    close.addEventListener('click', () => {
      if (activeRequest) activeRequest.abort();
      window.clearTimeout(debounceTimer);
      clearResults(results, input);
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });

    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (activeRequest) activeRequest.abort();
        window.clearTimeout(debounceTimer);
        clearResults(results, input);
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) {
        if (activeRequest) activeRequest.abort();
        clearResults(results, input);
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        closeNative(details);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
